import * as React from 'react';
import {
  EditCarModal_carFragment,
  UpdateCarMutation,
} from 'src/Components/CustomerPage/__generated__/EditCarDetailsForm.generated';
import { EditCarDetailsForm } from 'src/Components/CustomerPage/EditCarDetailsForm';
import { ScrollablePage } from 'src/Components/Shared/ScrollablePage';
import { LocationSection } from 'src/Components/ShopLocationOptionsPage/lib/LocationSection';
import { LocationSectionBody } from 'src/Components/ShopLocationOptionsPage/lib/LocationSectionBody';
import { LocationSectionHeader } from 'src/Components/ShopLocationOptionsPage/lib/LocationSectionHeader';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from 'src/shadcn/components/ui/sheet';

export interface IAppointmentCreateNewCarModalProps
  extends React.PropsWithChildren {
  car: EditCarModal_carFragment;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onCarUpdated: (newCar: UpdateCarMutation['updateCar']) => void;
}

export const AppointmentCreateNewCarModal: React.FunctionComponent<
  IAppointmentCreateNewCarModalProps
> = ({ car, isOpen, setIsOpen, onCarUpdated }) => {
  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetContent side={'bottom'} className='h-[60vh]'>
        <SheetHeader>
          <SheetTitle>Edit car</SheetTitle>
        </SheetHeader>
        <div className='col-span-2 flex h-full overflow-y-hidden'>
          <ScrollablePage>
            <div className='mt-8 pb-20'>
              <LocationSection>
                <LocationSectionHeader>
                  <span>Car information</span>
                </LocationSectionHeader>
                <LocationSectionBody>
                  <EditCarDetailsForm
                    car={car}
                    onCarSaved={newCar => {
                      setIsOpen(false);
                      onCarUpdated(newCar);
                    }}
                  />
                </LocationSectionBody>
              </LocationSection>
            </div>
          </ScrollablePage>
        </div>
      </SheetContent>
    </Sheet>
  );
};
